export default {
  items: [],
  unreadCount: 0,
  defaultGurudwaraId: null,
  loading: false,
  quickCounts: {
    prasad: 0,
    sarai: 0,
    hotel: 0,
    anandKaraj: 0,
    service: 0
  }
}
